//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
import CarInsuranceList from "./CarInsuranceList";
import CarUseList from "./CarUseList";
import CarAccidentList from "./CarAccidentList";
import CarRepairList from "./CarRepairList";
import CarExpendList from "./CarExpendList";
import CarGasolineList from "./CarGasolineList";
import CarInspectionList from "./CarInspectionList";
export default {
  name: 'CarDetailedList',
  mixins: [JeecgListMixin],
  components: {
    CarInsuranceList: CarInsuranceList,
    CarUseList: CarUseList,
    CarAccidentList: CarAccidentList,
    CarRepairList: CarRepairList,
    CarExpendList: CarExpendList,
    CarGasolineList: CarGasolineList,
    CarInspectionList: CarInspectionList
  },
  data: function data() {
    return {
      pageTitle: '车辆详细',
      carList: {},
      carId: '',
      url: {
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view',
        queryCarDetailed: '/ea/asset/car/queryCarDetailed/'
      }
    };
  },
  created: function created() {
    this.carId = this.$route.query.carId;

    if (this.carId == null) {
      this.returnDetailed();
    } else {
      this.loadCarList();
    }
  },
  computed: {},
  methods: {
    loadCarList: function loadCarList() {
      var that = this;
      that.carList = {};
      getAction(this.url.queryCarDetailed + this.carId).then(function (res) {
        if (res.success) {
          that.carList = res.result;
          that.carList.photo = that.getImageView(that.carList.photo);
        }
      });
    },
    getImageView: function getImageView(photo) {
      return this.url.imgerver + '/' + photo;
    },
    returnDetailed: function returnDetailed() {
      this.$router.push({
        path: '/assets/car/CarList'
      });
    }
  }
};